import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const CPRQuality = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>CPR Quality</InputLabel>
      <Select
        value={moduleValues?.['CPR Quality'] ?? ''}
        label="CPR Quality"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['CPR Quality']: e.target.value,
          }))
        }
      >
        {['Mechanical', 'Good', 'Adequate', 'Poor'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default CPRQuality
